import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import FlamaApp from './FlamaApp';







ReactDOM.render(
    <FlamaApp />, 
  document.getElementById('root')
);


    